import React from 'react';

const Header: React.FC = () => {
  return (
    <div className="flex justify-center mb-4 mt-2">
      <div className="flex items-center gap-1">
        <img src="/assets/Logo.svg" alt="Swipey" width="100" height="40" />
      </div>
    </div>
  );
};

export default Header;
